import { queryOptions, useMutation } from '@tanstack/react-query'

import { getManualQuotes, withdrawManualQuote } from './manual-quotes.service'

export const manualQuotesQueryOptions = () =>
  queryOptions({
    queryKey: ['manualQuotes'],
    queryFn: getManualQuotes,
  })

export const useWithdrawManualQuotes = () => {
  return useMutation({
    mutationFn: withdrawManualQuote,
  })
}
